class NavTogglesCloses {
  setPanelVisible() {
    console.log("setPanelVisible FUNCTION CALLED");
    document.getElementById("inside_panel_content_container").style.display = "initial";
    document.getElementById("inside_panel_content_container_mobi").style.display = "initial";
    document.getElementById("mySidepanel").style.transition = "0s";
    document.getElementById("mySidepanel").style.borderLeft = "1px rgb(232,232,232) solid";
  }

  closeNav() {
    console.log("closeNav FUNCTION CALLED");
    var width = $(window).width();
    var offset = (width - 0).toString() + "px";
    //document.getElementById("mySidepanel").style.left = offset;
    document.getElementById("mySidepanel").style.transition = "0.5s";
    document.getElementById("mySidepanel").style.width = "0px";
    document.getElementById("mySidepanel").style.padding = "0px";
    document.getElementById("inside_panel_content_container").style.display = "none";
    document.getElementById("inside_panel_content_container_mobi").style.display = "none";
    document.getElementById("mySidepanel").style.borderLeft = "0px";
    document.getElementById("arrow_panel").innerHTML = '<img src="/static/img/arrow_bottom_blue.png" style="height:10px; margin-bottom:5px">';
    sessionStorage["lateral_bar"] = "closed";
  }

  toggleNav(user_input) {
    console.log("This is the toggle nav this::", user_input);
    if (user_input.id == "arrow_panel") {
      if (sessionStorage["lateral_bar"] == "open") {
        console.log("Currently session storage lateral bar is open");
        console.log("Current lateral bar value::", sessionStorage["lateral_bar"]);
        // then close the sidebar
        var width = $(window).width();
        var offset = (width - 0).toString() + "px";
        //document.getElementById("mySidepanel").style.left = offset;
        document.getElementById("mySidepanel").style.transition = "0.5s";
        document.getElementById("mySidepanel").style.width = "0px";
        document.getElementById("mySidepanel").style.padding = "0px";
        document.getElementById("inside_panel_content_container").style.display = "none";
        document.getElementById("inside_panel_content_container_mobi").style.display = "none";
        document.getElementById("mySidepanel").style.borderLeft = "0px";
        document.getElementById("arrow_panel").innerHTML = '<img src="/static/img/arrow_bottom_blue.png" style="height:10px; margin-bottom:5px">';
        sessionStorage["lateral_bar"] = "closed";
        console.log("Now session storage lateral bar is closed");
      } else {
        console.log("Currently session storage lateral bar is closed");
        console.log("Current lateral bar value::", sessionStorage["lateral_bar"]);
        // then open the sidebar
        sessionStorage["lateral_bar"] = "open";
        var width = $(window).width();
        var offset = (width - 300).toString() + "px";
        //document.getElementById("mySidepanel").style.left = offset;
        document.getElementById("mySidepanel").style.padding = "20px";
        document.getElementById("mySidepanel").style.width = "250px";
        document.getElementById("arrow_panel").innerHTML = '<img src="/static/img/arrow_left_blue.png" style="width:10px; margin-bottom:7px">';
        console.log("Setting value of inside panel content container");
        document.getElementById("inside_panel_content_container").innerHTML = sessionStorage["org_analytics"];
        document.getElementById("inside_panel_content_container_mobi").innerHTML = sessionStorage["org_analytics"];
        new DrawOrgCharts().createFunctionalRowsLeftPanel();
        setTimeout("new NavTogglesCloses().setPanelVisible();", 500);
        console.log("Now session storage lateral bar is open");
      }
    } else {
      if (sessionStorage["lateral_bar"] == "open") {
        console.log("Currently session storage lateral bar is open");
        console.log("Current lateral bar value::", sessionStorage["lateral_bar"]);
        // then close the sidebar
        var width = $(window).width();
        var offset = (width - 0).toString() + "px";
        //document.getElementById("mySidepanel").style.left = offset;
        document.getElementById("mySidepanel").style.transition = "0.5s";
        document.getElementById("mySidepanel").style.width = "0px";
        document.getElementById("mySidepanel").style.padding = "0px";
        document.getElementById("inside_panel_content_container").style.display = "none";
        document.getElementById("inside_panel_content_container_mobi").style.display = "none";
        document.getElementById("mySidepanel").style.borderLeft = "0px";
        document.getElementById("arrow_panel").innerHTML = '<img src="/static/img/arrow_bottom_blue.png" style="height:10px; margin-bottom:5px">';
        sessionStorage["lateral_bar"] = "closed";
        console.log("Now session storage lateral bar is closed");
        // if(sessionStorage['panel_preexisting'] != '') {
        //     document.getElementById("inside_panel_content_container").innerHTML = sessionStorage['panel_preexisting']
        // }
      } else {
        console.log("Currently session storage lateral bar is closed");
        console.log("Current lateral bar value::", sessionStorage["lateral_bar"]);
        console.log("Current panel preexisting value::", sessionStorage["panel_preexisting"]);
        // then open the sidebar
        // createFunctionalRowsLeftPanel()
        var width = $(window).width();
        var offset = (width - 300).toString() + "px";

        //document.getElementById("mySidepanel").style.left = offset;
        document.getElementById("mySidepanel").style.padding = "20px";
        document.getElementById("mySidepanel").style.width = "250px";
        document.getElementById("arrow_panel").innerHTML = '<img src="/static/img/arrow_left_blue.png" style="width:10px; margin-bottom:7px">';
        // sessionStorage['panel_preexisting'] = document.getElementById("inside_panel_content_container").innerHTML
        console.log("Setting value of inside panel content container");
        document.getElementById("inside_panel_content_container").innerHTML = sessionStorage["export_panel"];
        document.getElementById("inside_panel_content_container_mobi").innerHTML = sessionStorage["export_panel"];
        // sessionStorage['panel_preexisting'] = document.getElementById("inside_panel_content_container").innerHTML
        setTimeout("new NavTogglesCloses().setPanelVisible();", 500);
        sessionStorage["lateral_bar"] = "open";
        console.log("Now session storage lateral bar is open");
      }
    }
    console.log("toggleNav FUNCTION CALLED");
  }
}

class PasswordReset {
  passwordResetPage() {
    console.log("passwordResetPage FUNCTION CALLED");
    sessionStorage["email"] = "";
    $("body").css("background-color", "rgb(36,116,204)");
    document.getElementById("all_content").innerHTML = document.getElementById("password_reset_page").innerHTML;
    new UtilityFunctions().activateToolTips();
  }
  passwordResetLinkPage() {
    console.log("passwordResetLinkPage FUNCTION CALLED");
    $("body").css("background-color", "rgb(36,116,204)");
    document.getElementById("all_content").innerHTML = document.getElementById("password_reset_link_page").innerHTML;
    new UtilityFunctions().activateToolTips();
  }

  confirmNewPassword() {
    console.log("confirmNewPassword FUNCTION CALLED");
    if (sessionStorage["password"] == "" || sessionStorage["confirm_password"] == "" || sessionStorage["password"] != sessionStorage["confirm_password"]) {
      document.getElementById("password_reset_link_error").innerHTML = '<br><span style="color:red">Please fill in all the fields and make sure the passwords match</span>';
      document.getElementById("password_reset_link_error_mobi").innerHTML = '<br><span style="color:red">Please fill in all the fields and make sure the passwords match</span>';
    } else {
      document.getElementById("password_reset_link_error").innerHTML = "";
      document.getElementById("password_reset_link_error_mobi").innerHTML = "";
      document.getElementById("password_reset_link_form_content").innerHTML =
        '<span style="font-size:18pt;font-weight: 500;">Updating your password...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
      document.getElementById("password_reset_link_form_content_mobi").innerHTML =
        '<span style="font-size:18pt;font-weight: 500;">Updating your password...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
      $.ajax({
        url: "/confirm_new_password",
        type: "POST",
        data: {
          reset_token_id: sessionStorage["reset_token_id"],
          password: sessionStorage["password"],
        },
        error: function (xhr, status) {
          var error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
        },
      }).done(function (data) {
        console.log("AJAX call to hit confirm_new_password ");
        console.log("This is the AJAX response from confirmNewPassword ", data);
        if (data.status == "password_reset_complete") {
          localStorage["email"] = data.user["email"];
          localStorage["user_id"] = data.user["_id"];
          localStorage["user"] = JSON.stringify(data.user);
          // sessionStorage['logon_status'] = 'true'
          new PageContents().setLogonStatus();
          // drift_append_email()
          // new PageContents().changePage("/org-chart");
          new PageContents().changePage("/lists");
        } else {
          localStorage["email"] = "";
          localStorage["user_id"] = "";
          localStorage["user"] = "";
          document.getElementById("all_content").innerHTML = document.getElementById("password_reset_link_page").innerHTML;
          document.getElementById("password_reset_link_error").innerHTML = '<br><span style="color:red">User not found</span>';
          document.getElementById("password_reset_link_error_mobi").innerHTML = '<br><span style="color:red">User not found</span>';
          new PageContents().setLogonStatus();
          // sessionStorage['logon_status'] = 'false'
        }
      });
    }
  }
}

class SessionStorageUpdates {
  updatePromptEnumTextareaList() {
    sessionStorage["prompt_enum_list"] = JSON.stringify($("#prompt_enum_textarea").textext()[0].tags()["_formData"]);
  }

  updateFirstName(user_input) {
    console.log("updateFirstName FUNCTION CALLED");
    console.log("First name updated too ::", user_input.value);

    sessionStorage["first_name"] = user_input.value;
  }

  updateFullName(user_input) {
    console.log("updateFullName FUNCTION CALLED");
    console.log("Full name updated too ::", user_input.value);
    sessionStorage["full_name"] = user_input.value;
  }

  updateLastName(user_input) {
    console.log("updateLastName FUNCTION CALLED");
    console.log("Last name updated too ::", user_input.value);
    sessionStorage["last_name"] = user_input.value;
  }

  updatePassword(user_input) {
    console.log("updatePassword FUNCTION CALLED");
    console.log("Password updated too ::", user_input.value);
    sessionStorage["password"] = user_input.value;
  }

  updatePasswordConfimation(user_input) {
    console.log("updatePasswordConfimation FUNCTION CALLED");
    sessionStorage["confirm_password"] = user_input.value;
  }

  updateCompanyName(user_input) {
    console.log("updateCompanyName FUNCTION CALLED");
    sessionStorage["company_name"] = user_input.value;
  }

  updateEmail(user_input) {
    console.log("updateEmail FUNCTION CALLED");
    console.log("Email updated too ::", user_input.value);
    var value_entered_by_user = user_input.value;
    if (["gmail", "hotmail", "yahoo", "msn"].some((v) => value_entered_by_user.includes(v))) {
      try {
        document.getElementById("signup_error").innerHTML = '<br><span style="color:red">Please use a valid business email :-)</span>';
      } catch (error) {
        console.log("Error:", error);
      }

      try {
        document.getElementById("login_error").innerHTML = '<br><span style="color:red">Please use a valid business email :-)</span>';
        document.getElementById("login_error_mobi").innerHTML = '<br><span style="color:red">Please use a valid business email :-)</span>';
      } catch (error) {
        console.log("Error:", error);
      }
    }

    sessionStorage["email"] = value_entered_by_user;
  }
  updatePhone(user_input) {
    console.log("updatePhone FUNCTION CALLED");
    console.log("updatePhone updated too ::", user_input.value);
    sessionStorage["phone"] = user_input.value;
  }

  updateLinkedinLink(user_input) {
    console.log("updateLinkedinLink FUNCTION CALLED");
    sessionStorage["linkedin_link"] = user_input.value;
  }

  updateheadline(user_input) {
    console.log("updatePersonName FUNCTION CALLED");
    sessionStorage["new_block_headline"] = user_input.value;
  }

  updateCountry(user_input) {
    console.log("updateCountry FUNCTION CALLED");
    sessionStorage["new_block_country"] = user_input.value;
  }

  updatePersonName(user_input) {
    console.log("updatePersonName FUNCTION CALLED");
    sessionStorage["new_block_person_name"] = user_input.value;
  }

  updatePersonTitle(user_input) {
    console.log("updatePersonTitle FUNCTION CALLED");
    sessionStorage["new_block_person_title"] = user_input.value;
  }
}

class Pages {
  refreshUserfromBackend() {
    var height = ($(window).height() - 184).toString(); // -188
    var width = $(window).width();

    console.log("This is the refreshUserfromBackend");
    $.ajax({
      url: "/refresh_user",
      type: "POST",
      data: { user_id: localStorage["user_id"], params: params_obj },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      var payment_plans = JSON.parse(sessionStorage["payment_plans"]);
      var geo = sessionStorage["geo_country_selected"];
      var paymentPlansGeoObj = new PaymentPlans().getPaymentPlansBasedonGeo(geo);

      var payment_geo_selected = sessionStorage["geo_country_selected"];
      console.log("AJAX to hit refresh_user ");
      console.log("This is the AJAX response ", data);
      if (typeof data != "string") {
        let plan_data = data["user"]["plan"];
        console.log("Plan data:", plan_data);

        if (plan_data["plan"] == "plan_0") {
          var current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Free</span>';
          date_next_renewal = "-"; //plan_data['date_next_renewal']
          let api_key_section = "";
          credits_topup_section = "";
        } else if (plan_data["plan"] == "plan_1") {
          var current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Startup</span>';
          var date_next_renewal = plan_data["date_next_renewal"];
          // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
          var credits_topup_section = document
            .getElementById("credits_topup_section_element")
            .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
            .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
            .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
            .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
            .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
            .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
            .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
            .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
            .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
            .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
            .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
        } else if (plan_data["plan"] == "plan_2") {
          console.log("got plan 2 ");
          var current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Small Business</span>';
          var date_next_renewal = plan_data["date_next_renewal"];
          try {
            // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
          } catch {
            // api_key_section = localStorage['user']
          }
          var credits_topup_section = document
            .getElementById("credits_topup_section_element")
            .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
            .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
            .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
            .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
            .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
            .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
            .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
            .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
            .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
            .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
            .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
        } else if (plan_data["plan"] == "plan_3") {
          var current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">' + "Enterprise" + "</span>";
          var date_next_renewal = plan_data["date_next_renewal"];
          // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
          var credits_topup_section = document
            .getElementById("credits_topup_section_element")
            .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
            .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
            .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
            .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
            .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
            .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
            .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
            .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
            .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
            .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
            .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
        } else {
          var current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">' + "Custom Plan" + "</span>";

          var date_next_renewal = plan_data["date_next_renewal"];
          // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
          var credits_topup_section = document
            .getElementById("credits_topup_section_element")
            .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
            .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
            .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
            .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
            .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
            .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
            .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
            .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
            .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
            .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
            .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
        }

        let total_credits_avalable = plan_data["credits"];
        try {
          var num_people_referred = plan_data["people_referred"].length;
        } catch {
          var num_people_referred = 0;
        }

        var num_people_referred_label = "users referred";
        var google_auth_status =
          data?.user?.google_auth_status == true
            ? `<span style="font-size:12pt;padding-inline: 10px; background-color:rgb(27 176 73); color:white; border-radius:5px; padding-block:5px">Connected</span>`
            : `<span style="font-size:11pt;padding-inline: 10px; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding-block:5px">pending</span>`;
        document.getElementById("all_content").innerHTML = document
          .getElementById("dashboard_page_element")
          .innerHTML.replace(/{screen_height}/g, height)
          .replace(/{email}/g, localStorage["email"])
          .replace(/{current_plan_label}/g, current_plan_label)
          .replace(/{google_auth_status}/g, google_auth_status)
          .replace(/{date_next_renewal}/g, date_next_renewal)
          .replace(/{total_credits_avalable}/g, total_credits_avalable)
          .replace(/{num_people_referred}/g, num_people_referred)
          .replace(/{num_people_referred_label}/g, num_people_referred_label)
          // .replace(/{api_key_section}/g, api_key_section)
          .replace(/{credits_topup_section}/g, credits_topup_section);

        document.getElementById("pricing_payment_section").innerHTML = document.getElementById("pricing_payment_data").innerHTML;
        new PaymentPlans().setDashboardPrices();
        initialiseFunctionRangeSliderValue();
        if (plan_data["plan"] == "plan_0") {
          document.getElementById("button_plan0").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
        } else if (plan_data["plan"] == "plan_1") {
          document.getElementById("button_plan1").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
        } else if (plan_data["plan"] == "plan_2") {
          document.getElementById("button_plan2").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
        }
        new UtilityFunctions().activateToolTips();
        // $('[data-toggle="tooltip"]').tooltip({
        //         placement : 'top'
        //     });
      } else {
        new UtilityFunctions().clearStoragesandReload();
        new PageContents().changePage("/#");
      }
      console.log(data.user);
      localStorage["user"] = JSON.stringify(data.user);
      new PageContents().setLogonStatus();
    });
  }

  resetLocalStorageCredentialsAndSetLogonStatus() {
    localStorage["email"] = "";
    localStorage["full_name"] = "";
    localStorage["user_id"] = "";
    localStorage["user"] = "{}";
    new PageContents().setLogonStatus();
  }

  dashboardPage() {
    console.log("dashboardPage FUNCTION CALLED");
    var height = ($(window).height() - 61).toString();
    sessionStorage["plans_billing"] = "monthly";
    var params_obj = updateParamsObj();
    new Pages().refreshUserfromBackend();
    mixpanel.track("DashboardLoaded", {});
  }
  signupPage() {
    console.log("signupPage FUNCTION CALLED");
    sessionStorage["email"] = "";
    sessionStorage["password"] = "";
    sessionStorage["confirm_password"] = "";
    sessionStorage["use_case"] = "";
    sessionStorage["full_name"] = "";
    $("body").css("background-color", "rgb(36,116,204)");

    // this is the special signup page for Jens marketing

    document.getElementById("all_content").innerHTML = document.getElementById("new_signup_page").innerHTML;
    new UtilityFunctions().setIntPhoneNumbers();
    new UtilityFunctions().activateToolTips();

    // if enter is pressed, then submit the form
    $(".enter_click").keydown(function (event) {
      var keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode == 13) {
        new PageContents().signUp();
      }
    });
    $("#signup_button_desktop").attr("tabindex", -1).focus();
  }

  privacyPage() {
    console.log("privacyPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("privacy_page").innerHTML;
  }

  eulaPage() {
    console.log("eulaPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("eula_page").innerHTML;
  }

  apiPage() {
    console.log("apiPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("api_docs_page").innerHTML;
  }
  pricingPage() {
    console.log("pricingPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("pricing_page").innerHTML;
    document.getElementById("pricing_page_pricing_payment_section").innerHTML = document.getElementById("pricing_payment_data").innerHTML;
    new PaymentPlans().setDashboardPrices();
    initialiseFunctionRangeSliderValue();
    if (sessionStorage["logon"] == "false") {
      changeSelectPricingPlantoSignup();
    }
  }

  loginPage() {
    console.log("loginPage FUNCTION CALLED");

    console.log("Got to login page function");
    console.log("This is the count access ting");
    try {
      $(sign_up_modal).modal("hide");
    } catch (error) {
      console.log("Error:", error);
    }
    // console.log(localStorage);
    var params_obj = updateParamsObj();
    // This goes directly to the damn app page if there were tokens in the localstorage hive
    if (localStorage["email"] != "" && localStorage["user_id"] != "" && localStorage["email"] != undefined && localStorage["user_id"] != undefined) {
      console.log("We are here boss for authentication");
      console.log("Çurrent paramsobj == ", sessionStorage["params_obj"]);
      $.ajax({
        url: "/auth/login",
        type: "POST",
        // headers: {'Cookie' : document.cookie },
        data: {
          email: localStorage["email"],
          user_id: localStorage["user_id"],
          params: params_obj,
          visitor_fp: sessionStorage["visitor_fp"],
        },
        error: function (xhr, status) {
          var error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
        },
      }).done(function (data) {
        console.log("AJAX to hit /auth/login ");
        console.log("This is the AJAX response ", data);
        console.log("This is after login back login is okay");
        console.log(data);
        if (data.status == "login_ok") {
          console.log("login is okay");
          localStorage["email"] = data.user["email"];
          localStorage["user_id"] = data.user["_id"];
          console.log("This is data.user:::", data.user);
          localStorage["user"] = JSON.stringify(data.user);
          new PageContents().setLogonStatus();
          new ProcessNodesStates().initializeSessionStorageforDropdowns();
          // sessionStorage['logon'] = 'true'
          // drift_append_email()
          new PageContents().setMixPanelAliasUser();
          new PageContents().setMixPanelIdentifyUser();
          // new PageContents().changePage("/org-chart");

          // Changing the starting point to lists page
          new Pages().switchAllContentToSearchPage();
          // new PageContents().changePage("/lists");
          new PageContents().changePage("/lists");
        } else {
          new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
          console.log("login is not  at all okay");
          // sessionStorage['email']=''
          // sessionStorage['password']=''
          // $("body").css("background-color","rgb(7,93,102)");
          document.getElementById("all_content").innerHTML = document.getElementById("new_login_page").innerHTML;
          // $('[data-toggle="tooltip"]').tooltip({
          // placement : 'top'
          // });
          new UtilityFunctions().activateToolTips();

          // if enter is pressed, then submit the form
          $(".enter_click").keydown(function (event) {
            var keyCode = event.keyCode ? event.keyCode : event.which;
            console.log(keyCode);
            if (keyCode == 13) {
              new PageContents().logIn();
            }
          });
          $("#login_button_desktop").attr("tabindex", -1).focus();
        }
      });
    } else {
      console.log("got here");
      console.log(" There are no tokens in the local storage hive, hence redirecting to Twenty frontend /welcome");
      new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
      new PageContents().changePage("/login");
    }
  }

  jobsPage() {
    console.log("jobsPage FUNCTION CALLED");
    var height = ($(window).height() - 122).toString();
    var height_for_onboarding_flow = ($(window).height() - 122 - 6).toString();
    var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br><span style="font-size:10pt">Searching your data...</span></div>';
    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = loader;
    let customer_status = JSON.parse(localStorage["user"])["plan"]["customer_status"];
    if (customer_status != "unpaid_customer") {
      document.getElementById("inside_panel_content_container").innerHTML = document.getElementById("inside_panel_content_account_element").innerHTML;
      document.getElementById("inside_panel_content_container_mobi").innerHTML = document.getElementById("inside_panel_content_account_element").innerHTML;
      console.log("got here for ajax call");
      document.getElementById("header_element").innerHTML = document.getElementById("org_chart_header_element").innerHTML;
      new ListPageElements().createAllJobsListings();
      document.getElementById("left_panel_toggle_navigation_companies").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_people").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.fontWeight = "900";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecoration = "underline";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecorationThickness = "3px";
      document.getElementById("linkedin_icon_header").innerHTML = "";
      // document.getElementById("toggle_navigation_companies_people").innerHTML= ""
      // document.getElementById("linkedin_icon_header").innerHTML= ""
      new LeftPanelDropdownFilters().loadFiltersPanel("jobs");
      new LeftPanelDropdownFilters().removeInputsinLeftPanel();
      new Pages().setLoginLogoutTopBar();
      document.getElementById("search_bar_search_center").style.display = "none";
      document.getElementById("right_panel_org_chart_people_companies").style.display = "none";
    } else {
      document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("payment_page").innerHTML;
    }
  }

  setLoginLogoutTopBar() {
    var displayEmail = (localStorage["email"] && localStorage["email"].length > 0)
      ? localStorage["email"]
      : "Account";
    if (sessionStorage["logon"] == "true") {
      var loggedin = true;
      document.getElementById("elements_loggedin_logged_out").innerHTML = document.getElementById("loggedin_elements").innerHTML.replace(/{email}/g, displayEmail);
      document.getElementById("elements_loggedin_logged_out_mobi").innerHTML = document.getElementById("loggedin_elements_mobi").innerHTML.replace(/{email}/g, displayEmail);
    } else {
      var loggedin = false;
      document.getElementById("elements_loggedin_logged_out").innerHTML = document.getElementById("loggedout_elements").innerHTML;
      document.getElementById("elements_loggedin_logged_out_mobi").innerHTML = document.getElementById("loggedout_elements_mobi").innerHTML;
    }
  }

  setAllContentLoginLogout() {
    console.log("searchPage FUNCTION CALLED");
    var height = ($(window).height() - 122).toString();
    var height_for_onboarding_flow = ($(window).height() - 122 - 6).toString();
    document.getElementById("all_content").innerHTML = document
      .getElementById("search_page_element")
      .innerHTML.replace(/{screen_height}/g, height)
      .replace(/{email}/g, localStorage["email"])
      .replace(/{height_panel}/g, height)
      .replace(/{height_for_onboarding_flow}/g, height_for_onboarding_flow);
    this.setLoginLogoutTopBar();
    new PageContents().setTopBar();
    new UtilityFunctions().initDownloadArxenaAppLink();
    // Removing the org toggle navigation temporarily so that user doesn't have to see the people and company tabs
    document.getElementById("toggle_navigation_companies_people").innerHTML = document.getElementById("toggle_navigation_companies_people_element").innerHTML;
    // This is for the left panel with the company details
    document.getElementById("inside_panel_content_container").innerHTML = document.getElementById("inside_panel_content_account_element").innerHTML;
    document.getElementById("inside_panel_content_container_mobi").innerHTML = document.getElementById("inside_panel_content_account_element").innerHTML;
  }

  switchAllContentToSearchPage() {
    new Pages().setAllContentLoginLogout();
    sessionStorage["org_analytics"] = document.getElementById("inside_panel_content_account_element").innerHTML;
    sessionStorage["current_focus"] = "orgcharts";
    console.log("got here for ajax call");
    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("start_search_element").innerHTML;
    document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("start_search_element").innerHTML;
  }

  searchPage() {
    this.switchAllContentToSearchPage();

    if (window.location.href.includes("people")) {
      new Toggle().togglePeople();
    } else if (window.location.href.includes("companies")) {
      new Toggle().toggleCompanies();
    } else if (window.location.href.includes("lists")) {
      new Toggle().toggleLists();
    } else {
      new Toggle().toggleOrgCharts();
    }
    try {
      document.getElementById("linkedin_icon_header").innerHTML = "";
    } catch (error) {
      console.log("Error:", error);
    }
  }

  listsPage() {
    console.log("plans FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("lists_page").innerHTML;
    new ListPageElements().setUpListsTable();
    try {
      console.log("Trying to close the damn modal");
      $(waiting_results_raw_string).modal("hide");
    } catch (error) {
      console.log("Error:", error);
    }
  }

  tablesPage() {
    console.log("tablesPage function Called");
    try {
      var table_name = typeof JSON.parse(sessionStorage["current_table"])["table_name"];
    } catch (error) {
      console.log("Error");
      var table_name = "undefined";
    }
    if (table_name === "undefined") {
      new PageContents().changePage("/login");
    } else {
      $("body").css("background-color", "white");
      console.log("this is the tables page!!!>>>>", sessionStorage["current_table"]);

      // setLoginLogoutTopBar()
      new Pages().setAllContentLoginLogout();
      document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("table_section_center").innerHTML;

      document.getElementById("left_search_filters").innerHTML = document
        .getElementById("left_panel_tables_list")
        .innerHTML.replaceAll("{table_id}", JSON.parse(sessionStorage["current_table"])["table_id"])
        .replaceAll("{table_name}", JSON.parse(sessionStorage["current_table"])["table_name"]);
      document.getElementById("right_panel_org_chart_people_companies").innerHTML = document.getElementById("right_panel_sublists_section").innerHTML;
      document.getElementById("header_element").innerHTML = document.getElementById("header_element_lists").innerHTML;
      new TablesPageComponents().setupRightPanelSublists();
      new Handsontables().loadHandsOnTable();
      new TablesPageComponents().setupTableName();
      new Toggle().setHeadlineLeftPanelUnderLineTabs("lists");

      document.getElementById("search_bar_search_center").style.display = "none";
      try {
        console.log("Trying to close the damn modal");
        $(waiting_results_raw_string).modal("hide");
      } catch (error) {
        console.log("Error:", error);
      }
    }
  }

  landingPage() {
    console.log("landingPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("new_landing_page").innerHTML;

    sessionStorage["landing_animation"] = 0;
    sessionStorage["testimonial"] = 0;
    setTimeout("new PastFunctions().landingAnimation()", 4000);

    document.getElementById("use_case_container").innerHTML = document.getElementById("use_case_sales_element").innerHTML;
    document.getElementById("user_case_navi_container").innerHTML = document.getElementById("use_case_navigator_element").innerHTML;
    $("#sales_use_case").toggleClass("usecase-selected");

    document.getElementById("use_case_container1").innerHTML = document.getElementById("use_case_sales_element_mobi").innerHTML;
    document.getElementById("user_case_navi_container1").innerHTML = document.getElementById("use_case_navigator_element_mobi").innerHTML;
    $("#sales_use_case_mobi").toggleClass("usecase_mobi-selected");
    new UtilityFunctions().activateToolTips();
  }
  frontPage() {
    console.log("frontPage FUNCTION CALLED");
    $("body").css("background-color", "white");
    document.getElementById("all_content").innerHTML = document.getElementById("new_front_page").innerHTML;
    if (sessionStorage["logon"] == "true") {
      document.getElementById("sign_up_button_front_page").innerHTML = "";
      var loginBtn = document.getElementsByClassName("landing_white_button")[1];
      if (loginBtn) {
        loginBtn.innerHTML = "Account";
        loginBtn.onclick = function () {
          new PageContents().changePage("/lists");
        };
      }
    }
  }
}


export { NavTogglesCloses, PasswordReset, SessionStorageUpdates, Pages };
if (typeof window !== 'undefined') {
  window.NavTogglesCloses = NavTogglesCloses;
  window.PasswordReset = PasswordReset;
  window.SessionStorageUpdates = SessionStorageUpdates;
  window.Pages = Pages;
}
